import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Teacher / Mentor APIs
// ──────────────────────────────────────────────

/**
 * Fetch all approved teachers (public - no auth required)
 * @param {{ language?: string }} params
 */
export const getTeachersApi = (params = {}) =>
  axiosInstance.get('/teacher-listing-web', { params }).then((res) => res.data);

/**
 * Fetch a single teacher by ID (public deeplink route)
 * @param {string} id
 */
export const getTeacherByIdApi = (id) =>
  axiosInstance.get(`/teacher/${id}`).then((res) => res.data);

/**
 * Follow a teacher (requires auth)
 * @param {string} followingId 
 */
export const followTeacherApi = (followingId) =>
  axiosInstance.post('/follow', { followingId }).then((res) => res.data);

/**
 * Unfollow a teacher (requires auth)
 * @param {string} followingId 
 */
export const unfollowTeacherApi = (followingId) =>
  axiosInstance.post('/unfollow', { followingId }).then((res) => res.data);

/**
 * Fetch all available languages
 */
export const getLanguagesApi = () =>
  axiosInstance.get('/languages').then((res) => res.data);

/**
 * Fetch all available countries
 */
export const getCountriesApi = () =>
  axiosInstance.get('/country').then((res) => res.data);
